export default "__VITE_ASSET__BPgWOt5r__"